import {GameTypeEnum} from '../../../../../shared/GameEnums'
import {RoomState} from '../../../../../shared/RoomState'
import {socket} from '../../../../shared/scripts/EntryShared'
import {SocketLobbySend} from '../../../../shared/scripts/socket/SocketLobbySend'
import {StorageWrapper} from '../../../../shared/scripts/StorageWrapper'

export class UIRoomCenterCheckboxController {
    private readonly checkboxDivPrivateGame: HTMLDivElement
    private readonly checkboxPrivateGame: HTMLInputElement
    private readonly checkboxDivHighKarmaGame: HTMLDivElement
    private readonly checkboxHighKarmaGame: HTMLInputElement
    private readonly checkboxDivHideBankCards: HTMLDivElement
    private readonly checkboxHideBankCards: HTMLInputElement
    private readonly checkboxDivFriendlyRobber: HTMLDivElement
    private readonly checkboxFriendlyRobber: HTMLInputElement
    private readonly checkboxDivOrderSelection: HTMLDivElement
    private readonly checkboxOrderSelection: HTMLInputElement

    constructor() {
        this.checkboxDivPrivateGame = document.getElementById('room_center_privategame') as HTMLDivElement
        this.checkboxPrivateGame = document.getElementById('room_center_checkbox_privategame') as HTMLInputElement
        this.checkboxDivHighKarmaGame = document.getElementById('room_center_highkarmagame') as HTMLDivElement
        this.checkboxHighKarmaGame = document.getElementById('room_center_checkbox_highkarmagame') as HTMLInputElement
        this.checkboxDivHideBankCards = document.getElementById('room_center_hidebankcards') as HTMLDivElement
        this.checkboxHideBankCards = document.getElementById('room_center_checkbox_hidebankcards') as HTMLInputElement
        this.checkboxDivFriendlyRobber = document.getElementById('room_center_friendlyrobber') as HTMLDivElement
        this.checkboxFriendlyRobber = document.getElementById('room_center_checkbox_friendlyrobber') as HTMLInputElement
        this.checkboxDivOrderSelection = document.getElementById('room_center_playorderselection') as HTMLDivElement
        this.checkboxOrderSelection = document.getElementById('room_center_checkbox_playorderselection') as HTMLInputElement
    }

    update(newRoomState: RoomState) {
        this.checkboxPrivateGame.checked = newRoomState.gameSetting.privateGame
        this.checkboxHighKarmaGame.checked = newRoomState.isHighKarmaGame()
        this.checkboxHideBankCards.checked = newRoomState.gameSetting.hideBankCards
        this.checkboxFriendlyRobber.checked = newRoomState.gameSetting.friendlyRobber
        this.checkboxOrderSelection.checked = newRoomState.gameSetting.playOrderSelectionActive

        this.checkboxDivPrivateGame.className = this.checkboxPrivateGame.checked ? 'room_option_item selected' : 'room_option_item deselected'
        this.checkboxDivHighKarmaGame.className = this.checkboxHighKarmaGame.checked ? 'room_option_item selected' : 'room_option_item deselected'
        this.checkboxDivHideBankCards.className = this.checkboxHideBankCards.checked ? 'room_option_item selected' : 'room_option_item deselected'
        this.checkboxDivFriendlyRobber.className = this.checkboxFriendlyRobber.checked ? 'room_option_item selected' : 'room_option_item deselected'
        this.checkboxDivOrderSelection.className = this.checkboxOrderSelection.checked ? 'room_option_item selected' : 'room_option_item deselected'
    }

    load(roomState: RoomState) {
        this.checkboxPrivateGame.checked = roomState.gameSetting.privateGame
        this.checkboxPrivateGame.onchange = () => {
            SocketLobbySend.clickedRoomSettingChangePrivateGame(this.checkboxPrivateGame.checked)
        }

        this.checkboxHighKarmaGame.checked = roomState.isHighKarmaGame()
        this.checkboxHighKarmaGame.onchange = () => {
            SocketLobbySend.clickedRoomSettingChangeHighKarmaGame(this.checkboxHighKarmaGame.checked)
        }

        this.checkboxHideBankCards.checked = roomState.gameSetting.hideBankCards
        this.checkboxHideBankCards.onchange = () => {
            SocketLobbySend.clickedRoomSettingChangeHideBankCards(this.checkboxHideBankCards.checked)
        }

        this.checkboxFriendlyRobber.checked = roomState.gameSetting.friendlyRobber
        this.checkboxFriendlyRobber.onchange = () => {
            const isFriendlyRobberActive = this.checkboxFriendlyRobber.checked
            StorageWrapper.setRoomFriendlyRobberActiveSetting(isFriendlyRobberActive)
            SocketLobbySend.clickedRoomSettingChangeFriendlyRobber(isFriendlyRobberActive)
        }

        this.checkboxOrderSelection.checked = roomState.gameSetting.playOrderSelectionActive
        this.checkboxOrderSelection.onchange = () => {
            SocketLobbySend.clickedRoomSettingChangePlayOrderSelection(this.checkboxOrderSelection.checked)
        }
        this.conditionallyReplaceHighKarmaWithPlayOrderSelection(roomState)
    }

    updateInteractabilityOfElements(roomState: RoomState) {
        const isGuest = roomState.isGuest(socket.controller.session.id)
        this.checkboxPrivateGame.disabled = UIRoomCenterCheckboxController.isPrivateGameBoxDisabled(roomState)
        this.checkboxHighKarmaGame.disabled = UIRoomCenterCheckboxController.isHighKarmaBoxDisabled(roomState)
        this.checkboxFriendlyRobber.disabled = isGuest
        this.checkboxHideBankCards.disabled = isGuest
        this.checkboxOrderSelection.disabled = isGuest
    }

    private static isPrivateGameBoxDisabled(roomState: RoomState): boolean {
        if(roomState.isGuest(socket.controller.session.id)) return true
        if(roomState.gameSetting.gameType == GameTypeEnum.CreatedTournamentRoom) return true
        return false
    }

    private static isHighKarmaBoxDisabled(roomState: RoomState): boolean {
        if(roomState.isGuest(socket.controller.session.id)) return true
        if(!roomState.isHostSubscribed()) return true
        if(roomState.isPrivateGame()) return true
        return false
    }

    private conditionallyReplaceHighKarmaWithPlayOrderSelection(roomState: RoomState) {
        const isTournamentRoom = roomState.gameSetting.gameType == GameTypeEnum.CreatedTournamentRoom
        this.checkboxDivHighKarmaGame.hidden = isTournamentRoom
        this.checkboxDivOrderSelection.hidden = !isTournamentRoom
    }
}
